import { useState, useEffect } from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "@/components/ui/use-toast";
export default function RolePermissions() {

  const [view, setView] = useState<"list" | "add" | "edit" | "details">("list");
  const [selectedRole, setSelectedRole] = useState<any>(null);
  const [roles, setRoles] = useState<any[]>([]);
  const [formData, setFormData] = useState({
    module: "Administrator Module",
    role_name: "",
    description: "",
  });

  const [activeTab, setActiveTab] = useState<"general" | "permission">("general");
  const [openSection, setOpenSection] = useState<string | null>(null);
  const [selectedItems, setSelectedItems] = useState<any>({});
  const [checkAll, setCheckAll] = useState(false);

  // ================= LOAD ROLES =================
  const loadRoles = async () => {
    const res = await fetch("/api/roles");
    const data = await res.json();
    if (data.ok) setRoles(data.rows);
  };

  useEffect(() => {
    loadRoles();
  }, []);

  // ================= FULL 62 MODULES =================
  const permissionsData: any = {
    "Attendance": ["Access to Attendence","Add Attendence","Delete Attendence","Update Attendence","View Attendence"],
    "Backup Data": ["Download Page"],
    "Bowser": ["Access to Bowser Sale","Access to Bowser Vehicle","Bowser Sale Add","Bowser Sale Delete","Bowser Sale Update","Bowser Vehicle Add","Bowser Vehicle Delete","Bowser Vehicle InActive","Bowser Vehicle Update"],
    "BowserCredit": ["Access to Credit","Add sale","Delete sale","Edit sale"],
    "BowserExpence": ["Access to expence","Add expence","Delete expence","Edit expence"],
    "BowserLubSale": ["Access to bowser Lub Sale","Add sale","Delete Sale","Edit Sale"],
    "BowserRecovery": ["Access to Recovery","Add Recovery","Delete Recovery","Edit Recovery"],
    "BowserSwipe": ["Access to Sale","Delete swipe","Edit swipe","Enter Swipe"],
    "Bunk User": ["Access to Bank user","Add Bunk Users","Edit Bunk User","In/Active Bunk Users","View Bunk Users"],
    "Business Crd/Debit Parties": ["Access","Create","Delete","InActive","Update"],
    "Business Crd/Debit Transaction": ["Access","Add","Delete","Update"],
    "Business Shifts": ["Access","Change status","Add Page"],
    "Cash Denominations": ["Access","Add","Delete","In/Active","Update","View"],
    "Create Pumps": ["Add Pumps","Delete Pumps","Edit Pumps"],
    "Credit Customer": ["Access","Add","Delete","Update"],
    "Credit limit": ["View Credit limit Reports"],
    "Credit Party E-bill": ["Access","Delete","Generate"],
    "Credit Sales": ["Access","Add","Delete","Update","View"],
    "Daily collection Report": ["View Daily collection"],
    "Daily Sale Rate": ["Access","Add","Delete","Update","View"],
    "Daily WetStock": ["Access","Add","Delete","Update","View"],
    "Dashboard": ["Access dashboard"],
    "Day Assignings": ["Access","Create","Delete","Update"],
    "Day Employee Sheet": ["Access","Delete","Add","Update"],
    "Day Settlement": ["Access","Add","Delete"],
    "Duty WorkShifts": ["Access","Create","Delete","Update"],
    "Emp. DayCash Collection": ["Access","Add","Delete"],
    "Employee": ["Access","Add","Delete","Update","View"],
    "Employee DutyPay": ["Access","Create Salary","Delete Payslip","Generate Payslip"],
    "Expenses": ["Access","Add","Delete","Update","View"],
    "Expenses Catogery": ["Access","Add","Delete","Update","View"],
    "Expiry Master": ["Access","Add","Delete","Update","View"],
    "Fuel Product": ["Access","Create","Delete","Update"],
    "Fuel Product Purchase": ["Access","Add","Delete","Update"],
    "Generate Print": ["Access","Add","Print"],
    "Godown": ["Access","Add","Delete","Update"],
    "Godown Material Transfer": ["Access","Create","Delete","Update"],
    "Guest Customer": ["Access","Add","Delete","Update","View"],
    "Lfr Purchase": ["Entry"],
    "Loan Interest": ["Access to Loan Intest","Loan Intest Add","Loan Intest Delete"],
    "Lubricant": ["Access","Create","Delete","Update","View"],
    "Lubricant Stock": ["Access Stock Status"],
    "Lubs Purchase": ["Access","Add","Delete","Update"],
    "Master entry": ["Master Entry Page"],
    "Meter Sale": ["Access","Add","Delete","Update","View"],
    "petty cash": ["Access","Edit","Delete"],
    "Print Templates": ["Access","Update"],
    "Pumps Setting": ["Access","Add","Delete","Update","View"],
    "Recovery": ["Access","Add","Delete","Update","View"],
    "Reports": ["Access Reports"],
    "Sales Officer": ["Access","Add","Update","View"],
    "Swipe": ["Access","Add","Delete","Update","View"],
    "Tank&Nozzels": ["Access","Add","Delete","Update"],
    "Tanker Sale": ["Access","Add","Delete","Update","View"],
    "User Roles": ["Access","Add","Delete","Update"],
    "Vendor": ["Access","Add","Delete","Update"],
    "Vendor Transaction": ["Access","Add","Delete","Update","View"],
    "WetStock Dump": ["Access","Add","Delete","Update","View"],
    "WetStock Report": ["Access"]
  };

  // ================= FUNCTIONS =================
  const handleSave = async () => {
    if (view === "add") {
      await fetch("/api/roles", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
    } else {
      await fetch(`/api/roles/${selectedRole._id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
    }

    await loadRoles();
    setView("list");
  };

  const handleEdit = (role: any) => {
    if (window.confirm("Are you sure you want to edit?")) {
      setSelectedRole(role);
      setFormData(role);
      setView("edit");
    }
  };

  const toggleCheck = (item: string) => {
    setSelectedItems((prev: any) => ({
      ...prev,
      [item]: !prev[item],
    }));
  };

  const handleCheckAll = () => {
    const newState = !checkAll;
    setCheckAll(newState);

    const updated: any = {};
    Object.values(permissionsData).flat().forEach((item: any) => {
      updated[item] = newState;
    });

    setSelectedItems(updated);
  };

  const buildPermissions = () => {
    const result: any = {};

    Object.keys(permissionsData).forEach((module) => {
      const selected = permissionsData[module].filter(
        (item: string) => selectedItems[item]
      );

      if (selected.length > 0) {
        result[module] = selected;
      }
    });

    return result;
  };

  const [savingPermissions, setSavingPermissions] = useState(false);

const savePermissions = async () => {
  setSavingPermissions(true);

  try {
    await fetch(`/api/roles/${selectedRole.role_name}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        permissions: buildPermissions(),
      }),
    });

    toast({ title: "Permissions updated successfully" });
    loadRoles(); // reload roles
  } catch (error) {
    console.error(error);
  } finally {
    setSavingPermissions(false);
  }
};

  // ================= LIST =================
  if (view === "list") {
    return (
      <div className="space-y-6">
        <h1 className="text-3xl font-bold">Role Permissions</h1>

        <div className="bg-white border shadow rounded-xl p-6">
          <Button className="bg-[#93d258] text-black mb-4" onClick={() => setView("add")}>
            + Add New
          </Button>

          <Table>
            <TableHeader className="bg-[#2d3a6d]">
              <TableRow>
                <TableHead className="text-white">Role Name</TableHead>
                <TableHead className="text-white">Description</TableHead>
                <TableHead className="text-white">Action</TableHead>
              </TableRow>
            </TableHeader>

            <TableBody>
              {roles.map((r) => (
                <TableRow key={r._id}>
                  <TableCell className="cursor-pointer font-bold text-[#1e2a58]"
                    onClick={() => {
                      setSelectedRole(r);
                      // 🔥 Fetch permissions from backend
                      const selected: any = {};
                      if (r.permissions) {
                        Object.values(r.permissions).forEach((actions: any) => {
                           actions.forEach((a: string) => {
                            selected[a] = true;
                          });
                        });
                      }

                      setSelectedItems(selected);
                      setCheckAll(false);
                      setView("details");
                   }}   >
                    {r.role_name}
                  </TableCell>

                  <TableCell>{r.description}</TableCell>

                  <TableCell>
                    <Button className="bg-[#0bd38a]" onClick={() => handleEdit(r)}>
                      Edit
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    );
  }

  // ================= ADD / EDIT =================
  if (view === "add" || view === "edit") {
    return (
      <div className="flex justify-center mt-10">
        <div className="w-full max-w-xl p-6 rounded-xl text-white"
          style={{ background: "linear-gradient(135deg,#4c5bd4,#6a7be7)" }}
        >
          <div className="space-y-4">

            <Input className="bg-white text-black"
              placeholder="Role Name"
              value={formData.role_name}
              onChange={(e) => setFormData({ ...formData, role_name: e.target.value })}
            />

            <Input className="bg-white text-black"
              placeholder="Role Description"
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            />

            <div className="flex justify-center gap-4 mt-6">
              <Button className="bg-gray-200 text-black" onClick={() => setView("list")}>
                Cancel
              </Button>

              <Button className="bg-[#93d258] text-black" onClick={handleSave}>
                SAVE
              </Button>
            </div>

          </div>
        </div>
      </div>
    );
  }

  // ================= DETAILS =================
  if (view === "details") {
    return (
      <div className="space-y-6">

        <Button onClick={() => setView("list")}>← Back</Button>

        <div className="flex gap-3">
          <Button onClick={() => setActiveTab("general")}>General Information</Button>
          <Button onClick={() => setActiveTab("permission")}>Role Permission</Button>
        </div>

        {activeTab === "general" && (
          <div className="bg-white p-6 rounded shadow max-w-xl space-y-4">
            <Input value={selectedRole.role_name} disabled />
            <Input value={selectedRole.description} disabled />
          </div>
        )}

        {activeTab === "permission" && (
          <div className="space-y-4">

            <div className="flex items-center gap-6">
              <Button className="bg-[#93d258] text-black" 
                disabled={savingPermissions}
                onClick={savePermissions}>
                {savingPermissions ? "Saving..." : "UPDATE USER PERMISSIONS"}
              </Button>

              <div className="flex items-center gap-2">
                <input type="checkbox" checked={checkAll} onChange={handleCheckAll} />
                Check and Uncheck
              </div>
            </div>

            <div className="grid grid-cols-3 gap-4">

              {Object.keys(permissionsData).map((section) => {
                const isOpen = openSection === section;

                return (
                  <div key={section} className="relative">

                    <div
                      className="bg-white text-[#2d3a6d] border px-4 py-3 flex justify-between cursor-pointer rounded hover:bg-blue-50"
                      onClick={() => setOpenSection(isOpen ? null : section)}
                    >
                      {section}
                      <span className={isOpen ? "rotate-45" : ""}>+</span>
                    </div>

                    {isOpen && (
                      <div className="absolute z-50 w-full bg-white border rounded shadow mt-1">
                        {permissionsData[section].map((item: any) => {
                          const isChecked = selectedItems[item];

                          return (
                            <div
                              key={item}
                              onClick={() => toggleCheck(item)}
                              className={`px-4 py-2 flex gap-2 cursor-pointer ${
                                isChecked ? "bg-[#2d3a6d] text-white" : "hover:bg-blue-100"
                              }`}
                            >
                              <input type="checkbox" checked={isChecked || false} readOnly />
                              {item}
                            </div>
                          );
                        })}
                      </div>
                    )}

                  </div>
                );
              })}

            </div>

          </div>
        )}

      </div>
    );
  }
}